// Click-to-jump for the rail section nav.
//
// Origin reference: docs/origin-reference/coursework-mechanic.tsx §2.
//
// The trap: scrollIntoView({behavior:"smooth"}) computes its target offset
// at call time. Lazy-mounted sections above the target that finish loading
// AFTER the smooth scroll has locked in will grow and push the target down.
// The browser then lands above where the user clicked.
//
// Fix: after the smooth scroll begins, watch the scroller's content for
// size changes for ~2s and re-jump (instant) to the target's current
// offset on every change. Then disconnect so we don't fight the user's
// next interaction.
//
// This module is plain TS (no React) so the widget vanilla port can import
// the same function.

const REANCHOR_WINDOW_MS = 2000;

export function goToSection(
  scroller: HTMLElement | null,
  id: string,
): void {
  if (!scroller) return;
  const target = document.getElementById(id) ?? scroller.querySelector<HTMLElement>(
    `[data-section-id="${cssAttr(id)}"]`,
  );
  if (!target) return;
  target.scrollIntoView({ behavior: "smooth", block: "start" });

  // Re-anchor on layout shifts in the content for REANCHOR_WINDOW_MS. The
  // ResizeObserver watches the scroller's first child (the content wrapper);
  // any growth above the target shifts its offset, and we re-jump.
  const content = scroller.firstElementChild;
  if (!content) return;
  const ro = new ResizeObserver(() => {
    const t = document.getElementById(id) ?? scroller.querySelector<HTMLElement>(
      `[data-section-id="${cssAttr(id)}"]`,
    );
    t?.scrollIntoView({ behavior: "auto", block: "start" });
  });
  ro.observe(content);
  window.setTimeout(() => ro.disconnect(), REANCHOR_WINDOW_MS);
}

function cssAttr(s: string): string {
  return s.replace(/["\\]/g, "\\$&");
}
